const appName = "ESMF Profiler";
const version = "0.2.0";

export { appName, version };
